import { getUserId } from '@/lib/cookies'

/**
 * A revalidatedQuery key for the signed-in user's own data. Scoped to the
 * user id, so switching accounts in one webview never shows the previous
 * account's copy (sign-in also clears the cache).
 */
export function ownKey(name: string): string {
    return `own:${getUserId()}:${name}`
}
